import { useParams } from "react-router-dom"
import styled from "styled-components"
import { getApps } from "../../utils/appUtils"

const Container = styled.div`
  padding: 20px;
  color: ${({ theme }) => theme.colors.text};
  height: 100%;
`

const ColumnGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const RowGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const Header = styled(RowGroup)`
  justify-content: space-between;
  flex-wrap: wrap;
`

const Title = styled.div`
  font-size: 24px;
  font-weight: bold;
`

const Group = styled.div`
  background: ${({ theme }) => theme.backgrounds.pure};
  border: ${({ theme }) => theme.borders.main};
  border-radius: ${({ theme }) => theme.borderRadius.main};
  padding: 20px;
`

const PanelTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
`

const MutedText = styled.div`
  color: ${({ theme }) => theme.colors.lightText};
  font-size: 13px;
`

const SeamlessIFrame = styled.iframe`
  border: none;
  height: 100%;
`

export default () => {
  const { app: appParam } = useParams()
  const apps = getApps()

  const app = apps.find(a => a.path === appParam)

  const {
    name,
    jobsUrl
  } = app || {}

  return (
    <Container>
      <ColumnGroup style={{ gap: '15px', height: '100%' }}>
        <Header>
          <ColumnGroup>
            <Title>Apps Job Viewer</Title>
            <MutedText>View job queries and info from other apps.</MutedText>
          </ColumnGroup>
          {/*
          <RowGroup>
            <Button onClick={fetchJobs}>
              <RowGroup>
                <FaSyncAlt />
                Refresh
              </RowGroup>
            </Button>
          </RowGroup>
          */}
        </Header>

        <Group style={{ flex: 1 }}>
          <ColumnGroup style={{ height: '100%' }}>
            <RowGroup style={{ justifyContent: 'space-between', flexWrap: 'wrap' }}>
              <PanelTitle>{name}</PanelTitle>
              {/*
              <Button onClick={fetchJobs}>
                <RowGroup>
                  <FaSyncAlt />
                  Refresh
                </RowGroup>
              </Button>
              */}
            </RowGroup>
            <SeamlessIFrame title='app' src={jobsUrl} />
          </ColumnGroup>
        </Group>
      </ColumnGroup>
    </Container>
  )
}
